/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GeneralSettingsService {
    /**
     * Get general settings
     * Get the general settings (typically a single record)
     * @returns any General settings
     * @throws ApiError
     */
    public static fdf72C73D24231337007E3C7952C6Ad1(): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/general-settings',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create or update general settings
     * Create or update general settings (typically a single record)
     * @param requestBody
     * @returns any General settings created/updated successfully
     * @throws ApiError
     */
    public static da2Bec58B4A565B7E3Ff3Cd8C9B0784(
        requestBody: {
            company_name?: string;
            address?: string;
            country?: number;
            state?: number;
            city?: number;
            pincode?: number;
            date_formet?: number;
            logo_img?: string;
            favicon_img?: string;
            timezone?: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/general-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get specific general settings
     * Retrieve details of general settings by ID
     * @param id General settings ID
     * @returns any General settings details
     * @throws ApiError
     */
    public static c6892Aafd2E9Ba0577F154B2685204(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/general-settings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `General settings not found`,
            },
        });
    }
    /**
     * Update general settings
     * Update existing general settings
     * @param id General settings ID
     * @param requestBody
     * @returns any General settings updated successfully
     * @throws ApiError
     */
    public static eb3Ad8F421380A29328Ff6735Be33E46(
        id: number,
        requestBody: {
            company_name?: string;
            address?: string;
            country?: number;
            state?: number;
            city?: number;
            pincode?: number;
            date_formet?: number;
            logo_img?: string;
            favicon_img?: string;
            timezone?: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/general-settings/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `General settings not found`,
                422: `Validation error`,
            },
        });
    }
}
